import { FC } from 'react';
import { Form } from 'antd';
import { Relatie } from '@/lib/types';
import { getManualInputVersion, ManualInputVersion } from './manual-input-version';
import { GrondteeltMilieugegevensV1 } from './v1/grondteelt-milieugegevens-v1';
import { GrondteeltMilieugegevensV2 } from './v2/grondteelt-milieugegevens-v2';
import { GrondteeltMilieugegevensV3 } from './v3/grondteelt-milieugegevens-v3';

const milieugegevensByVersion: Record<ManualInputVersion, FC> = {
  v1: GrondteeltMilieugegevensV1,
  v2: GrondteeltMilieugegevensV2,
  v3: GrondteeltMilieugegevensV3,
};

export const GrondteeltMilieugegevens: FC = () => {
  const form = Form.useFormInstance<Relatie>();
  const registratiejaar = form.getFieldValue('registratiejaar');
  const version = getManualInputVersion(registratiejaar);
  const Milieugegevens = version ? milieugegevensByVersion[version] : undefined;

  return Milieugegevens ? <Milieugegevens /> : null;
};
